import React from 'react';

const CookiesPage = () => {
  return (
    <div className="py-20 bg-white">
      <div className="container mx-auto px-6 max-w-4xl">
        <h1 className="text-3xl md:text-4xl font-bold text-[#007dc6] mb-8">Política de Cookies</h1>
        
        <div className="prose prose-lg text-gray-600">
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-800 mb-4">1. Qué son las Cookies</h2>
            <p>
              Las cookies son pequeños archivos de texto que se almacenan en su dispositivo cuando visita nuestro sitio web. 
              Nos ayudan a mejorar su experiencia de usuario y a entender cómo interactúa con nuestro contenido.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-800 mb-4">2. Tipos de Cookies que Utilizamos</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li><strong>Cookies esenciales:</strong> Necesarias para el funcionamiento básico del sitio.</li>
              <li><strong>Cookies de rendimiento:</strong> Nos ayudan a mejorar el rendimiento del sitio.</li>
              <li><strong>Cookies de funcionalidad:</strong> Permiten recordar sus preferencias.</li>
              <li><strong>Cookies analíticas:</strong> Nos ayudan a entender cómo los visitantes usan nuestro sitio.</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-800 mb-4">3. Control de Cookies</h2>
            <p>
              Puede controlar y/o eliminar las cookies como desee. Puede eliminar todas las cookies que ya están en su computadora 
              y configurar la mayoría de los navegadores para evitar que se coloquen. Sin embargo, si hace esto, es posible que 
              tenga que ajustar manualmente algunas preferencias cada vez que visite un sitio.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-800 mb-4">4. Cambios en la Política</h2>
            <p>
              Nos reservamos el derecho de modificar esta política en cualquier momento. Cualquier cambio será publicado en esta página 
              con la fecha de actualización correspondiente.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default CookiesPage;